import { render, staticRenderFns } from "./ShopEditionProductItemPicture.vue?vue&type=template&id=f892cfb0&scoped=true&"
import script from "./ShopEditionProductItemPicture.vue?vue&type=script&lang=js&"
export * from "./ShopEditionProductItemPicture.vue?vue&type=script&lang=js&"
import style0 from "./ShopEditionProductItemPicture.vue?vue&type=style&index=0&id=f892cfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f892cfb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VIcon,VImg,VLayout,VProgressCircular})
